import React, { useEffect, useState } from 'react'
import {Badge,Layout,message, Col, Row, Tabs,Button,DatePicker, ConfigProvider,Input,Upload} from 'antd'
import { sendHttpPostRequest } from '../../api/http-request'
import courseMainStyles from './course-main.module.less'
import zhCN from 'antd/lib/locale/zh_CN'
import './course.module.css'
import * as constants from '../../constants/constants'
import LoginRegisterModal from '../../component/modal/login-register/login-register'
import { checkUserLogin } from '../common/user-center/user-info'
import {ClockCircleOutlined, UploadOutlined, EditOutlined, CalendarOutlined, TeamOutlined, ExperimentOutlined,  PlayCircleOutlined, CheckCircleOutlined} from '@ant-design/icons'
import {MenuPreview,} from './menu/course-main-teacher-menu'
import CourseMainTeacherSlides from './slides/course-main-teacher-slides'
import CourseMainTeacherSetting from './setting/course-main-teacher-setting'
import CourseMainTeacherStudent from './student-list/course-main-teacher-student'
import { CourseMainTeacherTestList } from './test/course-main-teacher-test-list'
import CourseMainTeacherExamList from './exam/course-main-teacher-exam-list'
import CourseMainTeacherCases from './case/course-main-teacher-cases'
import MenuEdit from "./menu/course-main-teacher-menu-edit";

import courseBasicInfoStyle from "./course-edit-basicinfo.module.less";


import Icon from '@ant-design/icons'

import  { ReactComponent as editSvg }   from '../../static/image/module/edit.svg'
import { ReactComponent as eyeSvg }   from '../../static/image/module/eye.svg'
import { ReactComponent as publishSvg }   from '../../static/image/course/publish.svg'
import { ReactComponent as saveSvg }   from '../../static/image/course/save.svg'
import { ReactComponent as cancelSvg }   from '../../static/image/course/cancel.svg'

import  {ReactComponent as mymenuSvg }   from '../../static/image/course/mymenu.svg'
import { ReactComponent as myslidesSvg }   from '../../static/image/course/myslides.svg'
import { ReactComponent as mytestSvg }   from '../../static/image/course/mytest.svg'
import { ReactComponent as myexamSvg }   from '../../static/image/course/myexam.svg'
import { ReactComponent as myteamSvg }   from '../../static/image/course/myteam.svg'
import { ReactComponent as mysettingSvg }   from '../../static/image/course/mysetting.svg'

const mymenuIcon = (props:any) => (<Icon component={mymenuSvg} {...props} />)
const myslidesIcon = (props:any) => (<Icon component={myslidesSvg} {...props} />)
const mytestIcon = (props:any) => (<Icon component={mytestSvg} {...props} />)
const myexamIcon = (props:any) => (<Icon component={myexamSvg} {...props} />)
const myteamIcon = (props:any) => (<Icon component={myteamSvg} {...props} />)
const mysettingIcon = (props:any) => (<Icon component={mysettingSvg} {...props} />)


const editIcon = (props:any) => (<Icon component={editSvg} {...props} />)
const eyeIcon = (props:any) => (<Icon component={eyeSvg} {...props} />)
const publishIcon = (props:any) => (<Icon component={publishSvg} {...props} />)
const saveIcon = (props:any) => (<Icon component={saveSvg} {...props} />)
const cancelIcon = (props:any) => (<Icon component={cancelSvg} {...props} />)


import moment from 'moment';
const { RangePicker } = DatePicker;
const dateFormat = 'YYYY-MM-DD';
const {TextArea} = Input 

import GlobalCss from '@/global.module.less'
import { BACKEND_API_URL } from '../../constants/constants'

const { TabPane } = Tabs

import Cookies from 'js-cookie'
import LockedMenuPreview from './menu/locked-course-menu-preview'
import { useHistory } from 'react-router'

export interface Props {}

/** 教师课程主页面 */
export const CourseMainTeacher: React.FC<Props> = (props) => {
  const courseId = parseInt(window.location.search.split('&')[0].split('=')[1]) // 课程ID
  const tabKey = window.location.search.split('&')[1]
    ? window.location.search.split('&')[1].split('=')[1]
    : '1' // 标签页key

  const course_edit = window.location.search.split('&')[2]
    ? window.location.search.split('&')[2].split('=')[1]
    : '2' //


  const history = useHistory()

  const [course, setCourse] = useState(null as any) //课程信息

  
  const [courseName, setCourseName] = useState('') //课程名称
  const [courseDescription, setCourseDescription] = useState('') //课程介绍

  const [courseNameOrigin, setCourseNameOrigin] = useState('') //课程名称原始值
  const [courseDescriptionOrigin, setCourseDescriptionOrigin] = useState('') //课程介绍原始值

  const [courseCover, setCourseCover] = useState('') //课程封面路径
  const [courseStatus, setCourseStatus] = useState(null as any) //课程封面路径


  const today = moment().format(dateFormat) 
  const [startTime, setStartTime] = useState(today);//课程开始时间
  const endDefaultDate = moment().add(6, 'months').format(dateFormat)

  const [endTime, setEndTime] = useState(endDefaultDate);//课程结束时间



  const [courseEdit, setCourseEdit] = useState(course_edit)



  const [menuId, setMenuId] = useState(null as any) //课程大纲;

  const [menuMode, setMenuMode] =  useState(1) //大纲模式，预览-1 编辑-2;

  const [collegeId, setCollegeId] = useState(null as any) //教师信息
  const [assistant, setAssistant] = useState(null as any) //助教信息
  const [userId, setUserId] = useState(null as any) //当前教师信息

  const [activeTabkKey, setActiveTabkKey] = useState(tabKey as string) //1大纲，2课件，3实验，4作业，5考试，6统计，7学员，8设置

  useEffect(() => {
    queryCourse()
    /** 查询机构Id */
    sendHttpPostRequest(
      'account/api/query_teacher_authenticate',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
      },
      (response: any) => {
        if (response.code == -100 || !response.is_ok) {
              sessionStorage.setItem("previousurl",window.location.href )
              document.getElementById('show-login-modal')!.click()
        }
        if (response?.college_info?.college_id) {
          let _collegeId = response.college_info.college_id
          setCollegeId(_collegeId)
        }
        if (response?.teacher_info?.user_id) {
          let _userId = response.teacher_info.user_id
          setUserId(_userId)
          console.log('_userId', _userId);
        }
      }
    )
    sendHttpPostRequest(
      'course/api/get_student_role',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        course_id: courseId,
      },
      (response: any) => {
        if (response.code == 0) {
          let _courseId = response.data.is_assistant
          setAssistant(_courseId)
        }
      }
    )
  }, [])
  
  // 查询课程信息
  const queryCourse = () => {
    const sessionid = Cookies.get('sessionid')
    const queryData = {
      source: 1,
      course_id: courseId,
      sessionid: sessionid,
      sid: sessionid,
    }
    sendHttpPostRequest(
      'course/api/user_query_course_by_id',
      queryData,
      courseCallback
    )
  }


        /**
     * 保存课程回调
     * @param response
     */
        const saveCourseParamsInfoCallback = (response:any) => {
          message.destroy();
          if (response.code == -100) {
              // 没登录
              sessionStorage.setItem("previousurl",window.location.href )
              document.getElementById('show-login-modal')!.click()
          } else if (response.code == -501) {
              // 没权限
              window.location.href = '/login?next=course';
          } else if (response.is_ok == true) {
              message.success("课程信息保存成功~")
          }else {
              message.error(response.message);
          }
      }
  
      const saveCourseParams = (params: any) => {
          sendHttpPostRequest(
              'course/api/user_update_course',
              params,
              saveCourseParamsInfoCallback
          )
      }

      

        /**
       * 保存课程回调
       * @param response
       */
        const saveCourseInfoCallback = (response:any) => {
          message.destroy();
          if (response.code == -100) {
              // 没登录
              sessionStorage.setItem("previousurl",window.location.href )
              document.getElementById('show-login-modal')!.click()
          } else if (response.code == -501) {
              // 没权限
              window.location.href = '/login?next=course';
          } else if (response.is_ok == true) {
              message.success("课程信息保存成功~")
          }else {
              message.error(response.message);
          }
      }
  
      /**
       * 点击保存课程按钮
       */
      const saveCourse = () => {
          sendHttpPostRequest(
              'course/api/user_update_course',
              {
                  course_id:courseId,
                  name: courseName,
                  description: courseDescription,
                  cover: courseCover,
                  //menu_id: menuId,
                  start_time: startTime,
                  end_time: endTime,
                  sessionid: Cookies.get("sessionid"),
                  sid: Cookies.get("sessionid"),
              },
              (response: any) => {
                if (response.message == "success") {
                  setCourseName(courseName);
                  setCourseDescription(courseDescription);
                  setCourseNameOrigin(courseName);
                  setCourseDescriptionOrigin(courseDescription);
                  setCourseEdit('2');
                }
                saveCourseInfoCallback(response);
              },
          )
      }

  

    // 上传封面传参
    const uploadData = {
      sessionid: Cookies.get("sessionid"),
      sid: Cookies.get("sessionid"),
      course_id: courseId,
    }


    // 上传图片
    const uploadImageProps = {
      accept: '.png,.jpg,.jpeg,.gif,.svg',
      name: 'data_file',
      multiple: false,
      showUploadList: false,
      data: uploadData,
      action: constants.BACKEND_API_URL + 'course/api/course_upload_cover',
      onChange(info) {
          const { status } = info.file;
          if (status !== 'uploading') {
              console.log(info.file, info.fileList);
          }
          if (status === 'done') {
              if (info.file.response.is_ok) {
                  message.success(`图片${info.file.name}文件上传成功！`);
                  setCourseCover(info.file.response.url);
                  const params = {
                    sessionid: Cookies.get("sessionid"),
                    course_id: courseId,
                    sid: Cookies.get("sessionid"),
                    cover: info.file.response.url,
                   
                }
                  saveCourseParams(params);
              } else {
                  if (info.file.response.code == -100) {
                      // 未登录
                      const localPath = window.location.href.split(window.location.host)[1];
                      window.location.href = `/oam_login?next=${localPath}`;
                  } else if (info.file.response.code == -501) {
                      // 权限不足
                      const localPath = window.location.href.split(window.location.host)[1];
                      window.location.href = `/oam_login?next=${localPath}`;
                  } else {
                      message.error(info.file.response.message);
                  }
              }

          } else if (status === 'error') {
              message.error(`图片${info.file.name}文件上传失败了:(`);
          }
      },
      onDrop(e) {
          console.log('Dropped files', e.dataTransfer.files);
      },
  };

  // 查询课程接口回调
  const courseCallback = (response: any) => {
    console.log(response)
    message.destroy()
    if (response.code == -100) {
      // 未登录
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
      // window.location.href = '/login?next=/course';
    } else if (response.is_ok == true) {
      // 成功
      setCourse(response.query_info)
      setCourseName(response.query_info.name)
      setCourseNameOrigin(response.query_info.name)
      setCourseDescription(response.query_info.description)
      setCourseDescriptionOrigin(response.query_info.description)
      setMenuId(response.query_info.syllabus_id)
      setStartTime(response.query_info.start_time)
      setEndTime(response.query_info.end_time)
      //setCourseVisible(response.query_info.visible);
      //setLectureList(response.query_info.lecture_list);
      //setCaseList(response.query_info.case);
      setCourseCover(response.query_info.cover)
      setCourseStatus(response.query_info.course_status)

      //setStartTime(response.query_info.start_time);
      //setEndTime(response.query_info.end_time);
      //setOnlineCount(response.online_count);
    } else if (response.code == -501) {
      // 权限不足
      message.error('权限不足')
      // window.location.href = '/login?next=course';
    } else {
      message.error(response.message)
    }
  }


  const disabledDate = (current:any) => {
    return current && current < moment().startOf('day');
}

const onDateRangeChange = (dates,dateStrings) => {
    setStartTime(dateStrings[0]);
    setEndTime(dateStrings[1]);  
    
    console.log(endTime);
}

const onCourseNameChange = (e:any) => {
    setCourseName(e.target.value);
    //saveCourse();
}


  /**
   * 发布课程回调
   * @param response
   */
  const publishCourseInfoCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 没登录
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
      // window.location.href = '/login?next=course';
    } else if (response.code == -501) {
      // 没权限
      message.error('权限不足')
      // window.location.href = '/login?next=course';
    } else if (response.is_ok == true) {
      message.success('课程发布成功~')
      setCourseStatus('已发布')
    } else {
      message.error(response.message)
    }
  }

  /**
   * 点击发布课程按钮
   */
  const pushlishCourse = () => {
    sendHttpPostRequest(
      'course/api/user_publish_course',
      {
        course_id: courseId,
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
      },
      publishCourseInfoCallback
    )
  }

  const onCourseLearnClick = () => {
    if (!checkUserLogin()) {
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
    } else {
      if (course.recent_knowledge_url != '') {
        window.open(course.recent_knowledge_url)
      } else if (course.first_knowledge_url != '') {
        window.open(course.first_knowledge_url)
      } else {
        message.destroy()
        message.error('课程暂时无法学习，请稍候...')
      }
    }
  }

  const onCourseEditClick = () => {
    if (!checkUserLogin()) {
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
    } else {
      setCourseEdit('1')
      //window.location.href = '/course-main-teacher-edit?course_id=' + courseId
    }
  }


  const statusStyles= (courseStatus: string) => {
    if (courseStatus == '进行中') {
      return {color:'#0ea5e9', background:'#0ea5e91a'}
    } else if (courseStatus == '未发布') {
      return {color:'#6b7280', background:'#6b72801a'}
    } else if (courseStatus == '未开课') {
      return {color:'#ff9f43', background:'#ff9f431a'}
    } else if (courseStatus == '已结课') {
      return {color:'#10b981', background:'#10b9811a'}
    } else {
      return {}
    }
  }

  return (
    <Layout className={courseMainStyles.mainDiv} >
      <LoginRegisterModal></LoginRegisterModal>

     { courseEdit != '1' &&  
      <div className={courseMainStyles.courseHeaderWrapper}>
        <Row
          className={courseMainStyles.courseInfoDiv}
          align="middle"
          justify="start"
          wrap={false}
        >
          <Col flex="auto">
            <div className={courseMainStyles.courseName}>{courseName}
             
            </div>

            <div > 
              <Row wrap={false} align="middle" style={{marginBottom:24}} >   
                  <Col flex="40px" style={{marginRight:12}}> 
                    <div>
                      <img
                          style={{height:40, width:40, borderRadius:'50%'}}
                          className={GlobalCss.avatar}
                          src={BACKEND_API_URL + course?.teacher_avatar} 
                      /> 
                    </div>
                  </Col>
                  <Col flex="120px">
                    <div style={{textAlign:'left'}}>
                      <div style={{fontSize:14, color:'#6b7280'}}>主讲教师</div> 
                      <div className={courseMainStyles.courseTeacherName}>{course?.teacher_real_name == '' ? course?.teacher : course?.teacher_real_name}</div>
                    </div>
                  </Col>

                  <Col flex={'360px'} style={{marginRight:12}}>
                    <div className={courseMainStyles.datecourse}>
                      <CalendarOutlined  style={{color:'#07c160', marginRight:5}}/> 
                      开课时间：{startTime?.slice(0, 10)} 至 {endTime?.slice(0, 10)}
                    </div>
                </Col>

                <Col flex={"auto"}>
                  <div> 
                    
                    <span className={courseMainStyles.teacherCourseStatusTag}  style={statusStyles(courseStatus)}>
                       {courseStatus == '已结课'?<CheckCircleOutlined />: courseStatus == '进行中'?<PlayCircleOutlined />: <ClockCircleOutlined />} {courseStatus}
                    </span> 
                  </div>
                </Col>

              </Row>

            </div>

            <div style={{margin:'0 0 8px', fontSize:18, fontWeight:600}}>课程简介</div>
            <div title= {courseDescription} className={courseMainStyles.courseIntroduction} style={{marginBottom:0}}> 
              {courseDescription}
            </div>

          </Col>

          <Col flex="300px" style={{ marginLeft: 16, textAlign: "right" }}>
            <div >
              <img
                src={
                  courseCover && courseCover?.startsWith('http')
                    ? courseCover
                    : constants.BACKEND_URL + courseCover
                }

               className={courseMainStyles.courseImage}
              />
            </div>
          </Col>

        </Row>

         <div className={courseMainStyles.headerActionDiv} >

            
            {course?.is_course_teacher == true && 
              <span 
                className={courseMainStyles.BtnLight}
                onClick={onCourseLearnClick}
              >
               
                <Icon component={eyeIcon}/>  预览
              </span>
            }
         
              {course?.is_course_teacher == true && (
                <span
                  className={courseMainStyles.BtnDefault}
                  style={{marginLeft: 12}}
                  onClick={onCourseEditClick}
                >
                  <Icon component={editIcon}/> 编辑
                </span>
              )}
         
              {courseStatus == '未发布' && (
                <span
                  style={{marginLeft: 12}}
                  className={courseMainStyles.BtnDark}
                  onClick={() => {
                    pushlishCourse()
                  }}
                >
                
                  <Icon component={publishIcon}/>  发布
                </span>
              )}
          
        

         </div>
      </div> 
      }

      { courseEdit == '1' &&             
       <div className={courseMainStyles.courseHeaderWrapper}>
          <Row className={courseMainStyles.courseInfoDiv} align='middle' wrap={false}>
              <Col flex="auto">
                  <Input onChange={(event) => {onCourseNameChange(event);}} placeholder="请输入课程名称"   value={courseName} style={{marginBottom:16, fontSize:16,fontWeight:600,borderRadius:8,background:'#f9fafb', padding:'6px 12px'}}/>
                  <TextArea maxLength={500} placeholder="请输入课程介绍" 
                      style={{borderRadius:8,width:"100%",fontSize:16,background:'#f9fafb', padding:'6px 12px'}} 
                      autoSize={{minRows: 6, maxRows: 6}} 
                      value={courseDescription} 
                      onChange={(e)=>{setCourseDescription(e.target.value);}}
                      />
                  
                  <Row align='middle' style={{width:'100%', marginTop:10}} gutter={[4,0]}>
                      <Col flex="auto">
                          <ConfigProvider locale={zhCN}>


                          <div className={courseMainStyles.datecourse}>
                            <CalendarOutlined  style={{color:'#07c160', marginRight:5}}/> 
                            开课时间：<RangePicker allowClear={false} allowEmpty = {[false, false]} onChange={onDateRangeChange} size="small" style={{marginLeft:10}} format={dateFormat} disabledDate={disabledDate} value={[moment(startTime,dateFormat),moment(endTime,dateFormat)]}/> 
                          </div>
                          </ConfigProvider>
                      </Col>
              
                  </Row>
                  
              </Col>

              <Col flex='300px' style={{ marginLeft: 16, textAlign: "right" }} >
                  {course?.is_course_teacher &&
                  <Upload className={courseBasicInfoStyle.uploadImage} {...uploadImageProps}>
                      {courseCover ?
                          <div>
                              <img
                                  id="course-cover"
                                  className={courseBasicInfoStyle.courseImg}
                                  width={300}
                                  height={200}
                                  style={{borderRadius: 8}}
                                  src={courseCover?.startsWith("http") ? courseCover : constants.BACKEND_URL + courseCover}
                              />
                              <div className={courseBasicInfoStyle.editImageText}>
                                  <EditOutlined style={{ marginRight: 5}}/>修改课程封面
                                  <div style={{backgroundColor:'transparent',marginTop:6,color:'#ccc',fontSize:12,padding:'0 10px'}}>（ 提示：请上传格式为png、jpg、jpeg、gif、svg的图片，大小不得超过10M。）</div>   
                              </div>
                          </div> :
                          <div style={{
                              paddingTop: 75,
                              borderRadius: 6,
                              textAlign: "center",
                              width: 300,
                              height: 190,
                              border: "1px solid #00000073"
                          }}>
                              <div className={courseBasicInfoStyle.uploadImageText}>
                                  <UploadOutlined style={{color: '#07c160', marginRight: 5}}/>上传课程封面
                                  <div style={{marginTop:6,color:'#666',fontSize:12,padding:'0 10px'}}>（ 提示：请上传格式为png、jpg、jpeg、gif、svg的图片，大小不得超过10M。）</div>   
                              </div>
                          </div>
                      }
                  </Upload>
                  }
              </Col>

          </Row>


           <div className={courseMainStyles.headerActionDiv} >
                  {course?.is_course_teacher && <span className={courseMainStyles.BtnDark} onClick={(e)=>{saveCourse();}}> < Icon component={saveIcon}/> 保存 </span>}
                  <span style={{marginLeft:12}} className={courseMainStyles.BtnLight} onClick={()=>{setCourseEdit('2');setCourseName(courseNameOrigin);setCourseDescription(courseDescriptionOrigin);}} > < Icon component={cancelIcon}/>  取消 </span>
           </div>
                    
        </div>
        }

        <div className={courseMainStyles.courseTabsWrapper}>
          <Tabs
            onTabClick={(key, event) => {
              setActiveTabkKey(key)
            }}
            activeKey={activeTabkKey}
            //type="card"
            size="middle"
            tabPosition="top"
          >
            <TabPane tab={<div><Icon component={mymenuIcon}/> 大纲</div>} key="1">

            <div  >

                {  course?.is_course_teacher == true && 
                <Row wrap={false} align={"middle"} style={{margin: '0 0 24px'}}>
                  <Col span={12} style={{textAlign:'left'}}>
                      <div className={courseMainStyles.courseTabContentTitle}>课程大纲</div>
                  </Col>

                  <Col span={12} style={{textAlign:'right'}}>
                    <div >
                      <span
                        style={{fontSize:14, padding:'4px 12px'}}
                        className={courseMainStyles.BtnLight}
                        onClick={()=>{menuMode == 1? setMenuMode(2):setMenuMode(1)}}
                      >
                      {menuMode == 1? <Icon component={editIcon}/>:<Icon component={eyeIcon}/>}  {menuMode == 1? '编辑':'预览'} 
                      </span> 
                    </div>
                  </Col>
                </Row>
                  }
              {course?.syllabus_id > 0 && course?.is_course_teacher == true && menuMode == 1 &&(
                  <MenuPreview
                    menu_id={course?.syllabus_id}
                    course_id={course?.id}
                    course_user={'teacher'}
                    course_status={''}
                  />
                )}

              {course?.syllabus_id > 0 && course?.is_course_teacher == true &&  menuMode == 2 && (
                <MenuEdit menu_id={course?.syllabus_id} menu_obj="课程编辑" is_course_teacher={course?.is_course_teacher}/>
              )}


              {course?.syllabus_id > 0 &&
                course?.is_course_teacher == false && (
                  <LockedMenuPreview menu_id={course?.syllabus_id} />
                )}
              </div>

            </TabPane>

            {course?.is_course_teacher && (
              <TabPane tab={<div><Icon component={myslidesIcon}/> 课件</div>} key="2">
                  <div>
                    <CourseMainTeacherSlides
                    course={course}
                      course_id={course?.id}
                      is_course_teacher={course?.is_course_teacher}
                    />
                  </div>

              </TabPane>
            )}

            {course?.is_course_teacher && (
              <TabPane tab={<div><ExperimentOutlined /> 实验</div>} key="3">
                <CourseMainTeacherCases
                  course={course}
                  course_id={course?.id}
                  is_course_teacher={course?.is_course_teacher}
                />
              </TabPane>
            )}

            {course?.is_course_teacher && (
              <TabPane tab={<div><Icon component={mytestIcon}/>  作业</div>} key="4">
                {(collegeId || assistant) && (
                  <CourseMainTeacherTestList
                    course_id={courseId}
                    college_id={collegeId}
                    menu_id={course?.syllabus_id}
                    assistant={assistant}
                  />
                )}
              </TabPane>
            )}

            {course?.is_course_teacher && (
              <TabPane tab={<div><Icon component={myexamIcon}/>  考试</div>} key="5">
                {collegeId && (
                  <CourseMainTeacherExamList
                    course_id={courseId}
                    college_id={collegeId}
                    enable_exam={course?.enable_exam}
                    menu_id={course?.syllabus_id}
                    assistant={assistant}
                  />
                )}
              </TabPane>
            )}

            {course?.is_course_teacher && (
              <TabPane
                tab={
                  <div className={courseMainStyles.dotBadgeWrapper}>
                  <Badge
                    style={{ backgroundColor: '#ff4b50', right:-5, color:'#ff4d50'}}
                    count={course?.apply_count}
                    size="small"
                    offset={[10, 0]}
                  >
                    <div> <TeamOutlined/>  成员</div>
                  </Badge>
                  </div>
                }
                key="7"
              >
                <CourseMainTeacherStudent
                  course_id={course?.id}
                  assistant={assistant}
                  is_course_teacher={course?.is_course_teacher}
                  user_id={userId}
                  teacher_id={course?.teacher_id}
                  actionCallback={queryCourse}
                  
                />
              </TabPane>
            )}


          {course?.is_course_teacher && (
              <TabPane tab={<div><Icon component={mysettingIcon}/>  设置</div>} key="8">
                <CourseMainTeacherSetting course={course} />
              </TabPane>
            )}
          </Tabs>
        </div>
 
    
    </Layout>
  )
}

export default CourseMainTeacher
